<template>
  <v-dialog
    v-model="value"
    transition="dialog-top-transition"
    max-width="600px"
    persistent
  >
    <ref-properties-table :mode="'compact'"  :value="[refProperty]" @input="setValue" @onCloseWindow="doClose" />
  </v-dialog>
</template>

<script>
import RefPropertiesTable from '@/components/modules/references/refPropertiesTable'

export default {
  name: 'prjSelectRefPropertyDialog',
  components: { RefPropertiesTable },
  props: ['refProperty', 'value'],
  data () {
    return {
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {
    setValue (val) {
      console.log('prjSelectRefPropertyDialog retransmitting event INPUT with value ', val)
      this.$emit('onRefPropertyChanged', val.length ? val[0] : null)
      this.doClose()
    },
    doClose () {
      this.$emit('input', false)
    }
  },
  mounted () {
    console.log('prjSelectRefPropertyDialog mounted with property ', this.refProperty)
  }
}
</script>
